import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
    title: _ctx.$tt(_ctx.closing ? 'workspace-close-confirm' : 'workspace-reopen-confirm', {name: _ctx.name}),
    message: _ctx.$tt(_ctx.closing ? 'workspace-close-explain' : 'workspace-reopen-explain'),
    actions: _ctx.actions,
    onPick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit($event === 'go' ? 'confirmed' : 'cancelled'))),
    onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancelled')))
  }, null, 8, ["title", "message", "actions"]))
}